import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Loader2 } from "lucide-react";

interface CustomDocumentTabProps {
  title: string;
  content: string;
  onTitleChange: (value: string) => void;
  onContentChange: (value: string) => void;
  onSubmit: () => void;
  isLoading?: boolean;
}

export function CustomDocumentTab({
  title,
  content,
  onTitleChange,
  onContentChange,
  onSubmit,
  isLoading = false
}: CustomDocumentTabProps) {
  return (
    <ScrollArea className="flex-1 h-[60vh]">
      <div className="p-6 space-y-6">
        <div className="space-y-4">
          <div>
            <label htmlFor="title" className="text-sm font-medium">
              Tittel
            </label>
            <Input
              id="title"
              value={title}
              onChange={(e) => onTitleChange(e.target.value)}
              placeholder="Skriv inn dokumenttittel"
              className="mt-1.5"
              disabled={isLoading}
            />
          </div>
          <div>
            <label htmlFor="content" className="text-sm font-medium">
              Innhold
            </label>
            <Textarea
              id="content"
              value={content}
              onChange={(e) => onContentChange(e.target.value)}
              placeholder="Skriv inn dokumentinnhold"
              className="mt-1.5 min-h-[300px]"
              disabled={isLoading}
            />
          </div>
          <Button 
            onClick={onSubmit}
            className="w-full"
            disabled={!title || !content || isLoading}
          >
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Genererer dokument...
              </>
            ) : (
              'Opprett dokument'
            )}
          </Button>
        </div>
      </div>
    </ScrollArea>
  );
}